import React from 'react'
import {
    BackButton,
    BlocLocationField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue9() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Où habitez-vous actuellement ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton targetView={7} />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={50} time={2} />
            </div>
            <div className="Container">
                <BlocLocationField
                    key="key57"
                    nbcolumn={1}
                    linked_data_id="emprunteurs_hab_pays"
                    Pays
                    label="Pays"
                    placeholder="ex : France"
                />
                <Conditionnal
                    linked_data_id="emprunteurs_hab_pays"
                    isEqualTo
                    targetDataValueCompare={{ label: 'France', value: 'FRA' }}
                >
                    <BlocLocationField
                        key="key58"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_hab_actuelle_localisation"
                        Ville
                        label="Ville ou code postal"
                    />
                </Conditionnal>
            </div>


            <Conditionnal linked_data_id="emprunteurs_hab_pays" isNotEmpty>
                <Conditionnal
                    linked_data_id="emprunteurs_hab_actuelle_localisation"
                    isNotEmpty
                >
                    <div className="SubmitButtonContainer">
                        {' '}
                        <Button text="Suivant" targetView={10} />{' '}
                    </div>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="emprunteurs_hab_pays"
                    isNotEqualTo
                    targetDataValueCompare={{ label: 'France', value: 'FRA' }}
                >
                    <Conditionnal
                        linked_data_id="emprunteurs_hab_actuelle_localisation"
                        isEmpty
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={10} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
